import React from 'react';

import './styles.scss';

function Wrapper({children, className}) {
    return(
        <div className={`${className | ''} application-wrapper`}>
            {children}
        </div>
    );
}


export default Wrapper;
